'use strict';

$('body').on('click', '.variation-swatch-grade', function () {
    let $this = $(this);
    const $group = $this.closest('.vehicle-variants-card__color-switchers');
    $group.find('.variation-swatch-grade').removeClass('active');
    $(this).addClass('active');
});

$('body').on('click', '.vehicle-variants-card__color-switcher', function () {
    let $this = $(this);
    let $vehicleVariantsCard = $this.parents('.vehicle-variants-card').first();
    let $vehicleVariantsCardImage = $vehicleVariantsCard.find('.vehicle-variants-card__image').first();
    let $vehicleVariantsCardPrice = $vehicleVariantsCard.find('.vehicle-variants__price').first();
    let currentSelectedImage = $vehicleVariantsCardImage.data("variation-img-" + $this.data('variation-color'));
    let $vehicleVariantDesc = $vehicleVariantsCard.find('#vehicle-variant-desc').first();
    let $vehicleVariantsCardAvailability = $vehicleVariantsCard.find('#vehicle-variants-card-availability').first();
    $vehicleVariantsCardImage.attr('src', currentSelectedImage);
    $vehicleVariantsCardPrice.html($this.data('variation-price'));
    $vehicleVariantDesc.html($this.data('variation-desc'));

    $.ajax({
        url: $vehicleVariantsCardAvailability.data('action'),
        type: 'get',
        dataType: 'json',
        data: {
            pid: $this.data('variation-pid'),
        },
        success: function (response) {
            $vehicleVariantsCardAvailability.html(response.inventoryAvailabilityMessage.message);
            var $buildAndPriceCTA = $vehicleVariantsCard.find('#buildAndPriceCTA');
            var url = new URL($buildAndPriceCTA.attr('href'), window.location.origin);
            var parts = url.pathname.split('/');
            parts[parts.length - 1] = $this.data('variation-pid') + '.html';
            url.pathname = parts.join('/');
            $buildAndPriceCTA.attr('href', url.pathname);
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const tabButtons = document.querySelectorAll('#vehicle-variants-carousel-tabs button[role="tab"]');

    function updateButtonStyles() {
        tabButtons.forEach(button => {
            if (button.getAttribute('aria-selected') === 'true') {
                button.classList.remove('color--nutral-90');
            } else {
                button.classList.add('color--nutral-90');
            }
        });
    }

    updateButtonStyles();

    var el = document.querySelector('#vehicle-variants-carousel-tabs');
    if (el) {
        el.addEventListener('shown.bs.tab', function (event) {
            updateButtonStyles();
        });
    }

    tabButtons.forEach(button => {
        button.addEventListener('click', function () {
            setTimeout(updateButtonStyles, 10);
        });
    });
});


$('body').on('stores:updateLocationWithPortDealer:afterUpdate', () => {
    $('.vehicle-variants-card').each(function () {
        let $vehicleVariantsCard = $(this);
        let $vehicleVariantsCardAvailability = $vehicleVariantsCard.find('#vehicle-variants-card-availability').first();
        let $defaultVariantSwitch = $vehicleVariantsCard.find('.vehicle-variants-card__color-switcher').first();

        $.ajax({
            url: $vehicleVariantsCardAvailability.data('action'),
            type: 'get',
            dataType: 'json',
            data: {
                pid: $defaultVariantSwitch.data('variation-pid'),
            },
            success: function (response) {
                $vehicleVariantsCardAvailability.html(response.inventoryAvailabilityMessage.message);
            }
        });
    });
});
$(() => {

    var sliderConfig = {
        "slidesToShow": 3,
        "slidesToScroll": 1,
        "dots": false,
        "infinite": false,
        "arrows": true,
        "prevArrow": `<button type="button" class="slick-prev"><div class="icon icon-angle-left"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Size=L, Fill=Off, Direction=West"><path id="Union" d="M28.05 36.6785L15.3215 23.95L28.05 11.2215L30.8785 14.05L20.9785 23.95L30.8785 33.85L28.05 36.6785Z" fill="#fff"></path></g></svg></div></button>`,
        "nextArrow": `<button type="button" class="slick-next"><div class="icon icon-angle-right"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Size=L, Fill=Off, Direction=East"><path id="Union" d="M25.8215 23.95L15.9215 14.05L18.75 11.2215L31.4785 23.95L18.75 36.6785L15.9215 33.85L25.8215 23.95Z" fill="#fff"></path></g></svg></div></button>`,
        "responsive": [{
            "breakpoint": 768,
            "settings": {
                "arrows": false,
                "slidesToShow": 1.2,
                "slidesToScroll": 1,
                "variableWidth": false,
            }
        },
        {
            "breakpoint": 1023,
            "settings": {
                "arrows": false,
                "slidesToShow": 2.2,
                "slidesToScroll": 1,
                "variableWidth": false,
            }
        }]
    }

    function reInitVariationSlick() {
        $('#2wd-slider').slick('unslick');
        if ($('#2wd-slider').children().length > 1) {
            $('#2wd-slider').slick(sliderConfig);
        }

        $('#awd-slider').slick('unslick');
        if ($('#awd-slider').children().length > 1) {
            $('#awd-slider').slick(sliderConfig);
        }
    }

    $('#two-wd-tab').on('shown.bs.tab', function () { reInitVariationSlick() });
    $('#all-wd-tab').on('shown.bs.tab', function () { reInitVariationSlick() });

    if ($('#2wd-slider').children().length > 1) {
        $('#2wd-slider').slick(sliderConfig);
    }

    if ($('#awd-slider').children().length > 1) {
        $('#awd-slider').slick(sliderConfig);
    }

})
